import { TooltipV2 } from '@cimplico/components';
import { BuildingOffice2Icon, BuildingOfficeIcon, DocumentCheckIcon, SquaresPlusIcon } from '@heroicons/react/24/outline';
import { Entity } from '../../types/entity';
import { formatMixedCase } from '../../utilities/formatting';
import { ReactNode } from 'react';
import { EntityGroup, EntityIntegrations } from './EntityRow';
import { Link } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';

type EntityMetadataProps = {
    entity: Entity;
};

export default function EntityMetadata({ entity }: EntityMetadataProps): JSX.Element {
    const { shortId } = useFirmContext();

    return (
        <div className="flex gap-2 flex-wrap">
            <EntityMetadataItem label={formatMixedCase(entity.type)} tooltipMessage="Type" icon={<BuildingOfficeIcon />} />
            <EntityMetadataItem
                label={<EntityGroup showSmallColumns groups={entity.groups} />}
                tooltipMessage="Group"
                icon={<BuildingOffice2Icon />}
            />
            <EntityMetadataItem
                link={`/${shortId}/entities/${entity.id}?tab=workpapers`}
                label={entity.activeWorkpapers.length}
                tooltipMessage="Open Workpapers"
                icon={<DocumentCheckIcon />}
            />
            <EntityMetadataItem
                label={<EntityIntegrations showSmallColumns entity={entity} />}
                tooltipMessage="Integrations"
                icon={<SquaresPlusIcon />}
            />
        </div>
    );
}

type EntityMetadataItemProps = {
    label: string | ReactNode;
    tooltipMessage: string;
    icon: ReactNode;
    link?: string;
};

function EntityMetadataItem({ label, tooltipMessage, icon, link }: EntityMetadataItemProps): JSX.Element {
    return (
        <div className="flex text-xs gap-1 flex-nowrap">
            <TooltipV2 message={tooltipMessage} delayMs={750} position="bottom">
                <div className="w-4 h-4 text-gray-500 [&>*]:stroke-2">{icon}</div>
            </TooltipV2>
            {link ? (
                <Link to={link}>
                    <p className="text-gray-600 dark:text-gray-400 hover:underline">{label}</p>
                </Link>
            ) : (
                <p className="text-gray-600 dark:text-gray-400">{label}</p>
            )}
        </div>
    );
}
